import React from 'react';
import { FaExclamationTriangle, FaHome, FaRedo } from 'react-icons/fa';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error("Uncaught error:", error, errorInfo);
        this.setState({ errorInfo });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen bg-surface-muted flex items-center justify-center p-6">
                    <div className="max-w-md w-full bg-white rounded-[2.5rem] shadow-premium p-10 md:p-12 text-center">
                        <div className="w-20 h-20 bg-red-50 text-red-500 rounded-3xl flex items-center justify-center mx-auto mb-8 animate-bounce">
                            <FaExclamationTriangle size={32} />
                        </div>
                        <h1 className="text-3xl font-black text-primary tracking-tight mb-4">Something went wrong</h1>
                        <p className="text-gray-500 font-medium mb-10 text-sm">
                            An unexpected error occurred. We've been notified and are working to fix it.
                        </p>
                        
                        <div className="flex flex-col gap-3">
                            <button 
                                onClick={() => window.location.reload()}
                                className="w-full h-14 bg-primary text-white font-black rounded-full hover:bg-accent transition-all flex items-center justify-center gap-3 shadow-xl shadow-primary/20"
                            >
                                <FaRedo size={14} /> Refresh Page
                            </button>
                            <a 
                                href="/"
                                className="w-full h-14 bg-surface-muted text-primary font-black rounded-full hover:bg-surface-border transition-all flex items-center justify-center gap-3"
                            >
                                <FaHome size={14} /> Back to Home
                            </a>
                        </div>
                        
                        {process.env.NODE_ENV === 'development' && (
                            <div className="mt-10 p-4 bg-gray-50 rounded-2xl text-left overflow-auto max-h-40">
                                <p className="text-[10px] font-mono text-gray-400 uppercase tracking-widest mb-2">Error Details</p>
                                <pre className="text-xs font-mono text-red-400 whitespace-pre-wrap">
                                    {this.state.error?.toString()}
                                    {"\n\n"}
                                    {this.state.errorInfo?.componentStack}
                                </pre>
                            </div>
                        )}
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
